import React from "react";
import { useSelector } from "react-redux";
import { getFirstChar } from "../../../../helpers/common";

const QualificationJourney = ({
  handleOpenQualificationModal,
  componentType = "overview",
  initialData = null, // 🟢 Prop addition to directly consume Candidate profile payload data safely
}) => {
  // 🟢 FALLBACK: If initialData is provided, use it (and parse if stringified JSON). Otherwise, default to Redux.
  let qualifications = useSelector((state) => state.customer?.qualifications);

  if (initialData !== null) {
    qualifications =
      typeof initialData === "string"
        ? (function () {
            try {
              return JSON.parse(initialData);
            } catch (e) {
              return [];
            }
          })()
        : initialData;
  }

  console.log(
    "🔎 QualificationJourney render — qualifications:",
    qualifications,
  );

  // 🟢 FIXED: Updated string builder to read flat API keys first, falling back to nested block structures
  const getCollegeAndYear = (item, parsedAdditional) => {
    let collegeAndYear = "";

    const university =
      item?.university || parsedAdditional?.university_college || "";
    const start = item?.startYear || parsedAdditional?.start_year || "";
    const end = item?.endYear || parsedAdditional?.end_year || "";

    const hasYearAdded = start && end;

    if (university) {
      collegeAndYear += `${university} ${hasYearAdded ? "-" : ""} `;
    }

    if (hasYearAdded) {
      collegeAndYear += `(${start} - ${end})`;
    }

    return collegeAndYear;
  };

  // Safe parsing helper just in case additionalFields comes as a stringified object from old items
  const getParsedFields = (fieldData) => {
    if (!fieldData) return {};
    if (typeof fieldData === "object") return fieldData;
    try {
      return JSON.parse(fieldData);
    } catch (e) {
      return {};
    }
  };

  return (
    <>
      {qualifications && qualifications?.length > 0 ? (
        qualifications?.map((item) => {
          // 🟢 FIXED: Parse additionalFields safely for legacy data support
          const parsedAdditional = getParsedFields(
            item?.additionalFields || item?.additional_fields,
          );

          // 🟢 FIXED: Extract data looking at flat API structure first, then legacy additionalFields
          const courseTitle =
            item?.course || parsedAdditional?.title || "Qualification";
          const detailsText = item?.details || parsedAdditional?.details || "";
          const certificationText =
            item?.certification || parsedAdditional?.certification || "";

          return (
            <div
              key={item?.id}
              className="candidate-education-content mt-4 d-flex"
            >
              <div className="circle flex-shrink-0 bg-soft-primary">
                {getFirstChar(courseTitle)}
              </div>
              <div className="ms-4">
                <div className="d-flex">
                  <h6 className="fs-16 mb-1 me-3">{courseTitle}</h6>

                  {componentType === "update" ? (
                    <div
                      className="cursor-pointer"
                      onClick={() =>
                        handleOpenQualificationModal("update", item)
                      }
                    >
                      <i className="uil uil-edit"></i>
                    </div>
                  ) : null}
                </div>
                <p className="mb-2 text-muted">
                  {getCollegeAndYear(item, parsedAdditional)}
                </p>
                {detailsText && <p className="text-muted">{detailsText}</p>}

                {certificationText && (
                  <p className="text-muted">
                    <b>Certification:</b> {certificationText}
                  </p>
                )}
              </div>
            </div>
          );
        })
      ) : (
        <>
          <p className="mt-4 mb-5">
            No qualification information has been added.
          </p>
        </>
      )}
    </>
  );
};

export default QualificationJourney;
